import { gql, TypedDocumentNode } from "@apollo/client";

import { TemplateDeployment, QueryTemplateDeploymentArgs } from "types/generated";

type TemplateDeploymentData = {
  templateDeployment: TemplateDeployment;
};

export const TEMPLATE_DEPLOYMENT_QUERY: TypedDocumentNode<
  TemplateDeploymentData,
  QueryTemplateDeploymentArgs
> = gql`
  query TemplateDeployment($templateID: ID!, $id: ID!) {
    templateDeployment(templateID: $templateID, id: $id) {
      id
      name
      allowedActions
      description
      state
      template {
        id
      }
      templateVersion {
        id
        version
      }
      space {
        id
      }
      createdAt
      inputs {
        id
        value
        secret
        checksum
      }
      stacks {
        id
        name
        state
        outputs {
          id
          value
          description
          sensitive
        }
      }
    }
  }
`;
